/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasCellPresenterBase } from "./CanvasCellPresenterBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasVerticalSeparatorCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasVerticalSeparatorCellPresenter, _super);
    function CanvasVerticalSeparatorCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(CanvasVerticalSeparatorCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    CanvasVerticalSeparatorCellPresenter.$t = markType(CanvasVerticalSeparatorCellPresenter, 'CanvasVerticalSeparatorCellPresenter', CanvasCellPresenterBase.$);
    return CanvasVerticalSeparatorCellPresenter;
}(CanvasCellPresenterBase));
export { CanvasVerticalSeparatorCellPresenter };
//# sourceMappingURL=CanvasVerticalSeparatorCellPresenter.js.map
